import * as React from 'react';

import _ from 'underscore';

import type { SurveyOption } from 'bundles/refund/common/types';

import 'css!./__styles__/RefundReasonCheckboxContent';

type Props = {
  description: React.ReactNode;
  setAnswer: (reason: Array<string>) => void;
  reasons?: Array<SurveyOption> | null;
};

type State = {
  selectedReasons: Array<string>;
};

class RefundReasonCheckboxContent extends React.Component<Props, State> {
  state: State = {
    selectedReasons: [],
  };

  handleSelect = (e: React.MouseEvent<HTMLInputElement>): void => {
    const { selectedReasons } = this.state;
    const selectedReason = (e.target as HTMLInputElement).value;
    const alreadySelected = selectedReasons.includes(selectedReason);
    const newSelectedReasons = alreadySelected
      ? _(selectedReasons).without(selectedReason)
      : selectedReasons.concat(selectedReason);

    this.setState(() => ({ selectedReasons: newSelectedReasons }));
    this.props.setAnswer(newSelectedReasons);
  };

  renderReason = ({ id, text }: SurveyOption) => {
    return (
      <div key={id} className="horizontal-box">
        <input type="checkbox" id={id} name={id} value={id} className="reason-checkbox" onClick={this.handleSelect} />
        <label className="reason-label" htmlFor={id}>
          {text}
        </label>
      </div>
    );
  };

  render() {
    const { description, reasons } = this.props;

    if (!reasons) {
      return null;
    }

    return (
      <div className="rc-RefundReasonCheckboxContent">
        <p className="subtitle">{description}</p>
        <div>{reasons.map(this.renderReason)}</div>
      </div>
    );
  }
}

export default RefundReasonCheckboxContent;
